import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createUser } from "../Store/user/userSlice";

import styles from "../styles/User.module.scss";
import PasswordField from "./PasswordField";

const UserSignupForm = ({ toggleCurrentFormType, closeForm }) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    avatar: null,
    avatarPreview: "",
  });

  const handleChange = ({ target: { value, name, files } }) => {
    if (name === 'avatar' && files && files[0]) {
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        alert('Розмір зображення не повинен перевищувати 5 МБ');
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setValues(prev => ({
          ...prev,
          avatar: file,
          avatarPreview: reader.result
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!values.name || !values.email || !values.password) {
      alert("Заповніть усі обов'язкові поля");
      return;
    }

    try {
      await dispatch(createUser(values)).unwrap();
      closeForm();
    } catch (error) {
      alert(error || 'Не вдалося зареєструватися');
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.close} onClick={closeForm}>
        <svg className="icon">
          <use xlinkHref={`${process.env.PUBLIC_URL}/sprite.svg#close`} />
        </svg>
      </div>

      <div className={styles.title}>Зареєструватися</div>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.group}>
          <input
            type="email"
            placeholder="Ваш email"
            name="email"
            value={values.email}
            autoComplete="off"
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.group}>
          <input
            type="name"
            placeholder="Ваше ім'я"
            name="name"
            value={values.name}
            autoComplete="off"
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.group}>
          <PasswordField
            placeholder="Ваш пароль"
            name="password"
            value={values.password}
            autoComplete="new-password"
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.group}>
          <label htmlFor="avatar" style={{ display: 'block', marginBottom: '8px', color: '#fff' }}>
            Аватар (необов'язково)
          </label>
          {values.avatarPreview && (
            <div style={{ marginBottom: '10px' }}>
              <img 
                src={values.avatarPreview} 
                alt="Avatar preview" 
                style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #8b57c6' }}
              />
            </div>
          )}
          <input
            type="file"
            id="avatar"
            name="avatar"
            accept="image/*"
            onChange={handleChange}
            style={{ color: '#fff' }}
          />
        </div>

        <div
          className={styles.link}
          onClick={() => toggleCurrentFormType("login")}
        >
          У мене вже є акаунт
        </div>

        <button type="submit" className={styles.submit}>
          Зареєструватися
        </button>
      </form>
    </div>
  );
};

export default UserSignupForm;